<template>
  <div class="descricao-produto-monitoria">
    <div class="descricao-produto-monitoria-bloco">
      <div>
        <span>NCM:</span>
        <p>{{ produtosForm.ncm }}</p>
      </div>
      <div>
        <span>Ex:</span>
        <p>{{ ex }}</p>
      </div>
      <div>
        <span>Cest:</span>
        <p>{{ cest }}</p>
      </div>
    </div>
    <div class="descricao-produto-monitoria-bloco">
      <div>
        <span>Nome:</span>
        <p>{{ produtosForm.nome }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MonitoramentoDescricao",
  props: {
    produtosForm: Object
  },
  computed: {
    ex() {
      if (this.produtosForm.ex == "0") {
        return "-";
      }
      return this.produtosForm.ex;
    },
    cest() {
      if (this.produtosForm.cest == "0") {
        return "-";
      }
      return this.produtosForm.cest;
    }
  }
};
</script>

<style lang="scss" scoped>
.descricao-produto-monitoria {
  display: flex;
  flex-direction: column;
}
.descricao-produto-monitoria-bloco {
  display: flex;
  border-bottom: 1px solid var(--cinza03);
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  div {
    margin: 0 50px 0 10px;
    min-width: 50px;
    display: flex;
    span {
      margin: 0 5px;
      font-family: "Open Sans";
      font-weight: bold;
      font-size: 13px;
      text-transform: uppercase;
      color: #9ea2a7;
    }
    p {
      word-break: break-word;
    }
  }
}
</style>
